<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal" @click.stop>
      <div class="modal__head">
        <h3 class="modal__title">{{ type === 'update' ? 'Редактировать группу' : 'Создать группу' }}</h3>
        <div class="close" @click.stop="closeModal">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body">
        <div class="page__row">
          <div class="page__item">
            <AppInput title="Название группы:"
                      :value="state.name"
                      width="328px"
                      :valid="{}"
                      @value-changed="setGroupName"
            />
          </div>
          <div class="page__item">
            <AppColorPicker title="Цвет"
                            :value="state.color"
                            @value-changed="setGroupColor"
            />
          </div>
        </div>
        <div class="page__row mb-40">
          <AppSelectMultiple title="Добавить сотрудников"
                             placeholder="Выберите сотрудников"
                             :value="state.members"
                             :options="users"
                             :is-users="true"
                             @add-item="addGroupMember"
                             @remove-item="removeGroupMember"
          />
        </div>
        <div class="modal__button-wrap">
          <div class="modal__button">
            <AppButton title="Сохранить" type="main" @click.native="saveInfo"/>
          </div>
          <div class="modal__button">
            <AppButton title="Отмена" type="alt" @click.native="closeModal" v-if="type === 'update'"/>
            <AppButton title="Отмена" type="alt" @click.native="cancelCreation" v-else/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '../button/AppButton.vue'
import AppInput from '../input/AppInput'
import AppSelectMultiple from '../input/AppSelectMultiple'
import AppColorPicker from '@/components/page/input/AppColorPicker'

export default {
  name: 'user-groups-modal',
  components: {
    AppColorPicker,
    AppSelectMultiple,
    AppInput,
    AppButton
  },
  props: {
    state: {
      type: Object,
      default: () => {
        return {}
      }
    },
    type: {
      type: String,
      default: 'create'
    }
  },
  computed: {
    users () {
      return this.$store.getters['[dictionaries] usersList']
    }
  },
  methods: {
    loadOptions () {
      this.$store.dispatch('[dictionaries] getUserList')
    },
    saveInfo () {
      this.$emit('save-info')
    },
    closeModal () {
      this.$emit('close-modal')
    },
    cancelCreation () {
      this.$emit('cancel-creation')
    },
    setGroupName (name) {
      this.$emit('set-name', name)
    },
    setGroupColor (color) {
      this.$emit('set-color', color)
    },
    addGroupMember (user) {
      this.$emit('add-member', { id: user.id, name: user.name })
    },
    removeGroupMember (user) {
      this.$emit('remove-member', { id: user.id, name: user.name })
    }
  },
  mounted () {
    this.loadOptions()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  overflow: auto;
  align-items: flex-start;
  padding-top: 10vh;
}

.modal {
  max-width: 480px;

  &__text {
    text-align: center;
    color: $font_color_second;
    margin-bottom: 20px;
  }

  &__button-wrap {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }

  &__button {
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
